export default "__VITE_ASSET__BuBCg5qs__"